import { render, staticRenderFns } from "./SaasClipboard.vue?vue&type=template&id=7db50620&scoped=true&"
import script from "./SaasClipboard.vue?vue&type=script&lang=js&"
export * from "./SaasClipboard.vue?vue&type=script&lang=js&"
import style0 from "./SaasClipboard.vue?vue&type=style&index=0&id=7db50620&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db50620",
  null
  
)

export default component.exports